import { Link } from 'react-router-dom';
import Footer from '../components/Footer.jsx';
import { races, raceDateParts } from '../lib/content.js';

const DEFAULT_BANNER = '/images/default_trail_header-heading.jpg';

/** Race archive (archive-race.php), sorted by race date descending. */
export default function RaceListPage() {
  const sorted = [...races].sort((a, b) => String(b.date).localeCompare(String(a.date)));

  return (
    <>
      <div className="container-fluid" style={{ padding: 0 }}>
        <div className="row archive-header">
          <div className="col-2"></div>
          <div className="col-8 archive-header-text">Races</div>
          <div className="col-2"></div>
        </div>
        <div className="row archive-body">
          <div className="col-1"></div>
          <div className="col-10 archive-content">
            {sorted.map((race) => {
              const { month, day, year } = raceDateParts(race.date);
              return (
                <Link to={`/races/${race.slug}`} key={race.slug}>
                  <div className="row archive-row border-red">
                    <div className="col-2 flex-center flex-col archive-date">
                      <div className="row" style={{ fontSize: 40 }}>
                        {month}
                      </div>
                      <div className="row" style={{ fontSize: 75 }}>
                        {day}
                      </div>
                      <div className="row" style={{ fontSize: 25 }}>
                        {year}
                      </div>
                    </div>
                    <div className="col-5">
                      <img
                        className="img-fluid border-red"
                        style={{ borderRadius: 10 }}
                        src={race.headerImage || DEFAULT_BANNER}
                        alt={race.title}
                      />
                    </div>
                    <div className="col-5 flex-vert">
                      <div className="row" style={{ fontSize: 30 }}>
                        {race.title}
                      </div>
                      <div className="row">{race.tagline}</div>
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
          <div className="col-1"></div>
        </div>
      </div>
      <Footer />
    </>
  );
}
